import React, { useEffect, useState } from 'react';
import './UserProfile.css';
import UserComponent from '../../Components/UserComponent/UserComponent';
import AboutUser from '../../Components/AboutUser/AboutUser';
import Footer from '../../Components/Footer/Footer';
import { message } from 'antd';
import axiosInstance from '../../Config/axiosConfig';

function UserProfile({ setProfileImage }) {
  const [isEditing, setIsEditing] = useState(false);
  const [userData, setUserData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [tempImage, setTempImage] = useState(null);

  useEffect(() => {
    const loadUserData = () => {
      try {
        const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
        const userPhoto = localStorage.getItem('userPhoto');
        
        if (userInfo) {
          setUserData(userInfo);
        }
        
        // Only set tempImage if it's a valid base64 string
        if (userPhoto && isValidBase64(userPhoto)) {
          setTempImage(userPhoto);
        }
      } catch (error) {
        console.error('Error loading user data:', error);
      }
    };

    loadUserData();
  }, []);

  // Helper function to validate base64 image
  const isValidBase64 = (str) => {
    try {
      return str.startsWith('data:image') || 
             (str.length % 4 === 0 && /^[A-Za-z0-9+/]+={0,2}$/.test(str));
    } catch (e) {
      return false;
    }
  };

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleSave = async () => {
    setIsLoading(true);
    try {
      const accessToken = localStorage.getItem("accessToken");
      const storedDeviceId = localStorage.getItem("deviceId");
      const storedUserIp = localStorage.getItem("userIp");
      
      const formData = new FormData();
      formData.append('userId', userData.userId);
      formData.append('name', userData.name);
      formData.append('instructorTitle', userData.instructorTitle || '');
      formData.append('aboutInstructor', userData.aboutInstructor || '');
      
      // Only append if it's a File object (new upload)
      if (tempImage instanceof File) {
        formData.append('userPhotoFile', tempImage);
      } else if (tempImage === null) {
        // Explicitly handle photo removal
        formData.append('removePhoto', 'true');
      }

      const response = await axiosInstance.post('/user/update-profile', formData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "multipart/form-data",
          UserDevice: storedDeviceId,
          UserIPAddress: storedUserIp,
        },
      });

      if (response.data.code === 200) {
        message.success('Profile updated successfully');
        
        const updatedUserInfo = { 
          ...userData,
          name: response.data.data.name,
          instructorTitle: response.data.data.instructor_title,
          aboutInstructor: response.data.data.about_instructor,
        };
        
        setUserData(updatedUserInfo);
        localStorage.setItem("userInfo", JSON.stringify(updatedUserInfo));
        
        // Handle profile image update
        if (response.data.data.photo) {
          const fullPhotoUrl = response.data.data.photo.startsWith('data:image') 
            ? response.data.data.photo 
            : `data:image/jpeg;base64,${response.data.data.photo}`;
          
          localStorage.setItem('userPhoto', fullPhotoUrl);
          setTempImage(fullPhotoUrl);
          setProfileImage && setProfileImage(fullPhotoUrl);
        } else {
          localStorage.removeItem('userPhoto');
          setTempImage(null);
          setProfileImage && setProfileImage(null);
        }
      }
    } catch (error) {
      message.error('Error updating profile');
      console.error('Error:', error);
    } finally {
      setIsLoading(false);
      setIsEditing(false);
    }
  };

  const handleCancel = () => {
    // Revert to original image if canceled
    const originalPhoto = localStorage.getItem('userPhoto');
    setTempImage(originalPhoto);
    setIsEditing(false);
  };

  return (
    <div className="user-profile-container">
      <div className="profile-content">
        {isEditing ? (
          <div className="edit-actions">
            <span 
              className="edit-style" 
              onClick={handleSave}
              disabled={isLoading}
            >
              {isLoading ? 'Saving...' : 'Save'}
            </span>
            <span 
              className="edit-style" 
              onClick={handleCancel}
              disabled={isLoading}
            >
              Cancel
            </span>
          </div>
        ) : (
          <span className="edit-style" onClick={handleEdit}>
            Edit Profile
          </span>
        )}
        <div className="row-container">
          <UserComponent 
            isEditing={isEditing} 
            userData={userData} 
            profileImage={tempImage}
            setProfileImage={setTempImage}
            setUserData={setUserData}
          />
          <AboutUser 
            isEditing={isEditing} 
            userData={userData}
            setUserData={setUserData}
          />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default UserProfile;